import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
// ui
import { Box, Flex, ModalActionButton, ModalCancelButton } from '../../../ui';
//////////////////////////////////////////////////

const ButtonsBlock = ({
  buttons,
  saveAsNew,
  showSaveAsNew,
  saveAsNewBtnType,
}) => (
  <Box>
    {
      G.isTrue(showSaveAsNew) &&
      <ModalActionButton
        onClick={saveAsNew}
        type={R.or(saveAsNewBtnType, 'submit')}
      >
        {G.getWindowLocale('actions:save-as-new', 'Save As New')}
      </ModalActionButton>
    }
    {
      buttons.map((button, i) => (
        <ModalActionButton
          ml={20}
          key={i}
          onClick={button.action}
          width={R.or(button.width, 100)}
          type={R.or(button.type, 'submit')}
        >
          {button.btnText}
        </ModalActionButton>
      ))
    }
  </Box>
);

const SaveCancelBlock = ({
  save,
  width,
  formId,
  cancel,
  btnText,
  submitting,
  hideFormSaveBtn,
}) => (
  <Box>
    <ModalCancelButton ml={20} width={120} onClick={cancel}>
      {G.getWindowLocale('actions:cancel', 'Cancel')}
    </ModalCancelButton>
    {
      R.not(G.isTrue(hideFormSaveBtn)) &&
      <ModalActionButton
        ml={20}
        type='submit'
        form={formId}
        onClick={save}
        width={R.or(width, 150)}
        disabled={G.isTrue(submitting)}
      >
        {R.or(btnText, G.getWindowLocale('actions:save', 'Save'))}
      </ModalActionButton>
    }
  </Box>
);

export const ReportFormButtons = (props) => (
  <Flex
    left='0px'
    height={60}
    bottom='0px'
    width='100%'
    position='fixed'
    style={props.style}
    borderTop='1px solid'
    pl={R.or(props.pl, 60)}
    pr={R.or(props.pr, 15)}
    transition='all .2s linear'
    justifyContent='space-between'
    zIndex={R.or(props.zIndex, 12)}
    bg={G.getTheme('forms.actionsFooter.bgColor')}
    borderColor={G.getTheme('forms.actionsFooter.borderTopColor')}
  >
    <ButtonsBlock
      showSaveAsNew={props.showSaveAsNew}
      saveAsNew={props.handleClickSaveAsNew}
      saveAsNewBtnType={props.saveAsNewBtnType}
      buttons={R.pathOr([], ['buttons'], props)}
      additionBtns={R.pathOr([], ['additionBtns'], props)}
    />
    <SaveCancelBlock
      width={props.width}
      formId={props.formId}
      btnText={props.btnText}
      save={props.handleClickSave}
      submitting={props.submitting}
      cancel={props.handleClickCancel}
      hideFormSaveBtn={props.hideFormSaveBtn}
    />
  </Flex>
);
